<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      type="primary"
      @click="dialogVisible = true"
      >上传图片
    </el-button>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <el-upload
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        :action="actionPath"
        :http-request="handleFileChange"
        list-type="picture-card"
        :accept="accept"
        :upload-folder="uploadFolder"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
// import { getQiniuToken } from '@/api/common'
// import { guid } from '@/utils/index'
import AWS from 'aws-sdk'
export default {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff',
    },
    // 限制上传文件类型
    accept: {
      type: String,
      default: 'image/*,video/*',
    },
    // 上传文件夹
    uploadFolder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: [],
      actionPath: '',
      baseUrl: '',
      postData: {},
      s3: new AWS.S3({
        // AWS 认证相关
        accessKeyId: 'AKIA535ZCMMRQCQ4EXK7',
        secretAccessKey: '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',
        region: 'us-east-2',
      }),
      domain: 'https://img.hisynergy.shop/',
    }
  },
  mounted() {
    // getQiniuToken().then((response) => {
    //   console.log(response)
    //   this.actionPath = response.data.uploadUrl
    //   this.baseUrl = response.data.baseUrl
    //   this.postData.token = response.data.token
    // })
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        (item) => this.listObj[item].hasSuccess
      )
    },
    handleSubmit() {
      const arr = Object.keys(this.listObj).map((v) => this.listObj[v])
      if (!this.checkAllSuccess()) {
        this.$message(
          '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！'
        )
        return
      }
      console.log(arr)
      this.$emit('successCBK', arr)
      this.listObj = {}
      this.fileList = []
      this.dialogVisible = false
    },
    handleSuccess(response, file) {
      console.log(file)
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url =
            process.env.VUE_APP_AWS_S3_DOMAIN + response.key
          this.listObj[objKeyArr[i]].hasSuccess = true
          console.log(this.baseUrl + '/' + response.key)
          return
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]]
          return
        }
      }
    },
    beforeUpload(file) {
      console.log(file)
      const _self = this
      const _URL = window.URL || window.webkitURL
      const fileName = file.uid
      // this.postData.key = guid() + '.' + file.type.split('/')[1]
      this.listObj[fileName] = {}
      const img = new Image()
      img.src = _URL.createObjectURL(file)
      // img.onload = function() {
      //   _self.listObj[fileName] = { hasSuccess: false, uid: file.uid, width: this.width, height: this.height }
      // }
      this.listObj[file.uid] = {
        hasSuccess: false,
        uid: file.uid,
        name: file.name,
        width: this.width,
        height: this.height,
      }
      // return new Promise((resolve, reject) => {
      //   const img = new Image()
      //   img.src = _URL.createObjectURL(file)
      //   img.onload = function() {
      //     _self.listObj[fileName] = { hasSuccess: false, uid: file.uid, width: this.width, height: this.height }
      //   }
      //   resolve(true)
      // })
    },
    handleFileChange(option) {
      console.log(option)
      const file = option.file
      if (file) {
        // const key = guid() + "." + file.type.split("/")[1];
        const key = file.name
        const folder = this.uploadFolder + process.env.NODE_ENV + '/'
        const params = {
          Bucket: 'mlmvipsystem', // 存储佣名称
          Key: folder + key, // 文件名,重名会覆盖
          Body: file,
          ContentType: file.type,
        }
        const res = this.s3.upload(params)
        return res.promise()
      } else {
        this.$message('获取文件信息失败')
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep.el-upload--picture-card {
    width: 100%;
  }
}
</style>
